// extracted by mini-css-extract-plugin
export default {"modalka":"Modal_modalka__+1BWD"};